export default "__VITE_ASSET__f9215785__"